"use client";
import { useQuery } from "@tanstack/react-query";
import { getTextTestimonals } from "@/lib/actions/admin-dashboard/text-testimonal/get/getTextTestimonals";

export const useGetAllTextTestimonals = () => {
  return useQuery({
    queryKey: ["text-testimonals"],
    queryFn: getTextTestimonals,
  });
};